import React from 'react';
import styled, { css } from 'styled-components';
import Link from 'components/ui/Link';
import TranslatedText from 'components/i18n/TranslatedText';
import Icon from 'components/ui/Icon';
import usePageCreator from 'hooks/use-page-creator';
import { LinkButton } from 'components/admin2/ui/Button';
import { PageType } from 'models/IObject';
import { ADMIN_SURFACE_2 } from 'style/constants';
import { ADMIN_TEXT_LABEL_S_BOLD } from 'style/design-system/textStyles';

interface ICreationOptionsProps {
  onPageCreation: () => void;
}

export default function({ onPageCreation }: ICreationOptionsProps) {
  const [createNewPage] = usePageCreator();

  const pageCreationSetup = () => {
    onPageCreation();
  };

  const createNewChannel = () => {
    createNewPage?.(PageType.CHANNEL);
    pageCreationSetup();
  };
  const createNewLanding = () => {
    createNewPage?.(PageType.LANDING);
    pageCreationSetup();
  };

  const linkProps = {
    plain: true,
    sameTab: true,
  };

  return (
    <CreationOptions>
      <PageOption disabled={!createNewPage}>
        <Link {...linkProps}>
          <PageIcon name="channelMock" onClick={createNewChannel}/>
        </Link>
        <StyledLinkButton
          {...linkProps}
          onClick={createNewChannel}
          data-testid="createChannelButton"
        >
          <TranslatedText stringKey="ADMIN_ACTION_CREATE_PAGE" />
        </StyledLinkButton>
      </PageOption>
      <PageOption disabled={!createNewPage}>
        <Link {...linkProps}>
          <PageIcon name="landingMock" onClick={createNewLanding}/>
        </Link>
        <StyledLinkButton
          {...linkProps}
          onClick={createNewLanding}
          data-testid="createPageButton"
        >
          <TranslatedText stringKey="ADMIN_ACTION_CREATE_LANDING_PAGE" />
        </StyledLinkButton>
      </PageOption>
    </CreationOptions>
  );
}

const CreationOptions = styled.div`
  display: flex;
  gap: 4px;
  flex: 0;
`;

const PageOption = styled(Link).attrs(() => ({
  plain: true,
  sameTab: true,
}))<{ disabled: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 140px;
  height: 134px;
  padding: 8px;
  gap: 8px;
  background: ${ADMIN_SURFACE_2};
  border-radius: 5px;
  cursor: default;
  ${({ disabled }) => disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `}
`;

const StyledLinkButton = styled(LinkButton)`
  ${ADMIN_TEXT_LABEL_S_BOLD}
`;

const PageIcon = styled(Icon)`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 124px;
  max-height: 86px;
  & svg {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`;
